import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { v4 } from 'uuid';
import { MappingContext } from './MappingContext';
import { mappingReducer } from './MappingReducer';

const MappingProvider: FC<IContainerChildrenProps> = ({ children }) => {
  const [state, dispatch] = useReducer(mappingReducer, {
    locked: false,
    selected: undefined,
    mappingSchema: null,
    sourceSchema: null,
    targetSchema: null,
    mappingSummary: null,
    structureHashId: v4(),
    validationMessages: {}
  });

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <MappingContext.Provider value={{ state, dispatch }}>{children}</MappingContext.Provider>;
};

export default MappingProvider;
